export default {
    PAGE: {
        USER: {
            DOWNLOADS: '/downloads',
        },
    },
    API: {
        BENUTZERDOWNLOADS: '/user/download',
    },
};
